{
  "zh-TW": {
    "placeholders": {
      "name": "名稱",
      "description": "描述",
      "login": "使用者名稱或電子郵件",
      "username": "使用者名稱",
      "twoFactorCode": "兩步驟驗證碼",
      "confirmationCode": "確認碼",
      "email": "電子郵件",
      "currentPassword": "目前密碼",
      "password": "密碼",
      "passwordConfirmation": "確認密碼",
      "homepage": "首頁",
      "discord": "Discord 伺服器",
      "youtube": "Youtube 頻道",
      "twitch": "Twitch 頻道",
      "distance": "距離",
      "guilded": "Guilded 伺服器",
      "color": "顏色",
      "title": "標題",
      "classification": "戰鬥、工業、多用途...",
      "focus": "輕型戰鬥機、採礦、貨運...",
      "minSize": "小艇、小型、中型...",
      "maxSize": "中型、大型、主力艦...",
      "minCrew": "最少船員",
      "minCargo": "SCU",
      "modelId": "搜尋飛船",
      "scenario": "Xenothreat、Pirate Swarm、賞金任務…",
      "briefing": "詳細簡報 — 通訊頻道、呼號、交戰規則…",
      "location": "Stanton、Pyro、ARC-L1…",
      "meetupLocation": "Daymar、太空港 — 4 號機庫…",
      "maxAttendees": "選填上限",
      "autoLockMinutesBefore": "60",
      "timezone": "UTC",
      "startsAt": "選擇開始日期與時間",
      "endsAt": "選擇結束日期與時間（選填）",
      "notes": "會多帶彈藥、可以擔任支援、10 分鐘後抵達…",
      "signup-status": "確定參加還是暫定？",
      "features": {
        "username": "Username or User ID",
        "fleetFid": "Fleet FID or Fleet ID",
        "name": "功能名稱"
      },
      "fleetInviteToken": "艦隊邀請",
      "quicksearch": {
        "models": "Avenger, Carrack, Cutlass...",
        "models-fleetchart": "Avenger, Carrack, Cutlass...",
        "hangar": "Enterprise, Andromeda...",
        "hangar-fleetchart": "Enterprise, Andromeda...",
        "hangar-wishlist": "Avenger, Carrack, Cutlass..."
      },
      "search": {
        "default": "Search the Verse...",
        "roadmap-progress-tracker": "搜尋"
      },
      "home": {
        "search": "搜尋飛船..."
      },
      "container-1": "0",
      "container-2": "0",
      "container-4": "0",
      "container-8": "0",
      "container-16": "0",
      "container-24": "0",
      "container-32": "0",
      "image": {
        "caption": "標題"
      },
      "model": {
        "length": "長度",
        "beam": "寬度",
        "height": "高度",
        "price": "價格",
        "pledgePrice": "質押價格",
        "onSale": "販售中",
        "mass": "質量",
        "minCrew": "最少船員",
        "maxCrew": "最多船員",
        "storeUrl": "Store URL",
        "salesPageUrl": "Sales Page URL",
        "rsiId": "RSI ID",
        "scKey": "SC Key",
        "erkulIdentifier": "Erkul Identifier",
        "productionNote": "生產備註",
        "scmSpeed": "SCM Speed",
        "scmSpeedBoosted": "SCM Speed Boosted",
        "maxSpeed": "最大速度",
        "reverseSpeedBoosted": "Reverse Speed Boosted",
        "quantumFuelTankSize": "量子燃料箱大小",
        "hydrogenFuelTankSize": "氫燃料箱大小",
        "yaw": "Yaw",
        "pitch": "Pitch",
        "roll": "Roll",
        "yawBoosted": "偏航（增強）",
        "pitchBoosted": "俯仰（增強）",
        "rollBoosted": "翻滾（增強）",
        "fleetchartOffsetLength": "艦隊圖表長度偏移",
        "fleetchartOffsetBeam": "艦隊圖表寬度偏移",
        "extendedLength": "展開長度",
        "extendedBeam": "展開寬度",
        "extendedHeight": "展開高度",
        "extendedFleetchartOffsetLength": "展開艦隊圖表長度偏移",
        "extendedFleetchartOffsetBeam": "展開艦隊圖表寬度偏移",
        "cargo": "貨物",
        "baseModel": "基礎型號",
        "scIdentifier": "SC Identifier"
      },
      "cargoHold": {
        "offsetX": "偏移 X",
        "offsetY": "偏移 Y",
        "offsetZ": "偏移 Z",
        "rotation": "0 or 90"
      },
      "manufacturer": {
        "longName": "全名",
        "code": "代碼",
        "scRef": "SC Ref"
      },
      "fundingGoal": {
        "title": "伺服器費用、網域、Discord...",
        "description": "選填，會公開顯示的說明",
        "amount": "100.00",
        "currency": "EUR",
        "effectiveFrom": "2026-01-01",
        "endedAt": "持續進行請留空"
      },
      "supporterContribution": {
        "name": "公開顯示的支持者名稱",
        "amount": "5.00",
        "currency": "EUR",
        "startedAt": "2026-01-01",
        "endedAt": "2026-12-31",
        "note": "選填的內部備註"
      },
      "component": {
        "componentClass": "組件類別",
        "componentType": "組件類型",
        "componentSubType": "組件子類型",
        "itemType": "物品類型",
        "size": "尺寸",
        "grade": "等級",
        "scKey": "SC Key",
        "scRef": "SC Ref"
      },
      "modelPaint": {
        "pledgePrice": "質押價格",
        "productionStatus": "生產狀態",
        "productionNote": "生產備註"
      },
      "fleet": {
        "fid": "艦隊 ID",
        "rsiSid": "RSI SID",
        "ts": "Teamspeak 伺服器",
        "description": "描述",
        "discord": {
          "guildId": "例如 123456789012345678",
          "channelId": "活動使用的語音頻道 ID",
          "webhookUrl": "https://discord.com/api/webhooks/…",
          "webhookConfigured": "已儲存 — 留空即保留現有設定"
        },
        "guilded": "Guilded 伺服器",
        "homepage": "首頁",
        "twitch": "Twitch 頻道",
        "youtube": "Youtube 頻道"
      },
      "adminUser": {
        "passwordConfirmation": "確認密碼"
      },
      "user": {
        "rsiHandle": "RSI 使用者名",
        "location": "e.g. Berlin, Germany",
        "currentSystem": "e.g. Stanton, Pyro, Nyx"
      },
      "oauthApplication": {
        "name": "我的應用程式",
        "redirectUri": "https://example.com/callback",
        "scopes": "公開"
      },
      "vehicle": {
        "serial": "Serial"
      },
      "itemPrice": {
        "price": "0.00",
        "location": "位置",
        "locationUrl": "位置 URL"
      },
      "video": {
        "url": "YouTube Video ID"
      },
      "modelModule": {
        "name": "模組名稱",
        "price": "0.00",
        "pledgePrice": "0.00",
        "productionStatus": "已公佈, 可飛行, 概念中...",
        "scKey": "SC Key",
        "search": "按名稱搜尋模組..."
      },
      "modelUpgrade": {
        "name": "升級名稱",
        "pledgePrice": "0.00",
        "description": "描述"
      },
      "modelModulePackage": {
        "name": "套餐名稱",
        "pledgePrice": "0.00",
        "description": "描述"
      },
      "dock": {
        "name": "停靠口名稱"
      },
      "modelPosition": {
        "name": "職位名稱",
        "position": "0"
      },
      "modelHardpoint": {
        "name": "掛載點名稱",
        "key": "hardpoint_key",
        "details": "詳情",
        "mount": "掛載類型",
        "itemSlots": "0",
        "loadoutIdentifier": "配置標識"
      },
      "modelHardpointLoadout": {
        "name": "配置名稱"
      },
      "logistics": {
        "inventoryName": "Main Depot, Cargo Bay...",
        "description": "Optional details about this inventory",
        "location": "e.g. Port Olisar, Area18",
        "itemName": "Titanium, Medical Supplies..."
      },
      "filters": {
        "vehicles": {
          "name": "Enterprise, Andromeda...",
          "priceLt": "價格 <=",
          "priceGt": "價格 >="
        },
        "models": {
          "name": "Gladius, Andromeda...",
          "shipRole": "貨船、主力艦、戰鬥機...",
          "classification": "載具、戰鬥機、貨船...",
          "manufacturer": "Origin, Robert Space Industries, Aegis...",
          "onSale": "是或否",
          "productionStatus": "已公佈、可飛行、概念階段..."
        },
        "modelModules": {
          "name": "Bio Dome, Cargo Module..."
        },
        "manufacturers": {
          "name": "Origin, Robert Space Industries, Aegis..."
        },
        "supporterContributions": {
          "name": "Alice、Bob...",
          "startedAtGteq": "2026-01-01",
          "startedAtLteq": "2026-12-31"
        },
        "adminNotifications": {
          "search": "標題或內容..."
        },
        "users": {
          "search": "使用者名稱或電子郵件",
          "username": "使用者名稱",
          "rsiHandle": "RSI 使用者名",
          "email": "電子郵件"
        },
        "components": {
          "name": "名稱"
        },
        "fleets": {
          "name": "名稱",
          "fid": "FID",
          "members": {
            "username": "使用者名稱"
          }
        },
        "destroyedFleets": {
          "nameOrFid": "名稱或 FID"
        },
        "commodities": {
          "name": "Name",
          "uexCode": "UEX Code"
        },
        "equipment": {
          "name": "Name"
        },
        "notifications": {
          "search": "標題或內容..."
        }
      },
      "commodity": {
        "commodityType": "Commodity Type",
        "uexId": "UEX ID",
        "uexCode": "UEX Code",
        "scKey": "SC Key",
        "scRef": "SC Ref"
      },
      "equipment": {
        "equipmentType": "Equipment Type",
        "itemType": "Item Type",
        "subType": "Sub Type",
        "weaponClass": "Weapon Class",
        "size": "Size",
        "grade": "Grade",
        "scKey": "SC Key",
        "scRef": "SC Ref"
      }
    }
  }
}
